/**
 * A page that wants the report opened FILLED — the roster's "Report @handle"
 * (issue 633) — raises this on window with `{ category, handle }` as detail;
 * the layout, which owns the modal, opens it with that as `initial`.
 *
 * It lives apart from `ReportModal` so the layout can listen for it while the
 * modal itself loads only when someone first opens it.
 */
export const REPORT_PROBLEM_EVENT = 'tdt:report-problem';
